import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';

const SimpleDropdown = (
  {
    label,
    value,
    optionDisplay,
    onChange,
    options,
  },
) => {
  return (
    <FormControl fullWidth>
      <InputLabel>
        {label}
      </InputLabel>
      <Select
        value={ value }
        onChange={ (e) => {
          onChange(e.target.value);
        } }
      >
        <MenuItem value={ null }>
          None
        </MenuItem>
        {
          options?.map((option) => {
            return (
              <MenuItem key={ option.id } value={ option.id }>
                {optionDisplay(option)}
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
};

export default SimpleDropdown;
